// Generated hooks do not pass subjectType at runtime; the Eppo provider uses
// this flag metadata to choose the subject key from static OpenFeature context.
export const EPPO_FLAG_SUBJECT_TYPES = {
    'projects-brain-suggestions': 'user_nextauth_id',
    'paywall-in-modal-redesign': 'visitor_id',
    'multimodal-web-openai-live-voice-enabled': 'user_nextauth_id',
    'ms-office-computer-access-check': 'user_nextauth_id',
    'sessions-page-experiment': 'user_nextauth_id',
    'graphql-sidebar-v2': 'user_nextauth_id',
    'artifact-sheet-redesign': 'user_nextauth_id',
    'marketing-computer-affiliate-enabled': 'visitor_id',
    'model-config-readiness-from-query-state': 'visitor_id',
    'amex-partnership-bonus': 'user_nextauth_id',
    'ask-deep-research-computer-config': 'user_nextauth_id',
    'anthropic-model-provider-disable-toggle-for-admin': 'user_nextauth_id',
    'api-computer-analytics': 'user_nextauth_id',
    'api-console-decisions-playground-enabled': 'user_nextauth_id',
    'decisions-computer-missing-attachment': 'user_nextauth_id',
    'api-console-model-comparison-enabled': 'user_nextauth_id',
    'api-console-oauth-consent-enabled': 'user_nextauth_id',
    'api-console-sonar-migration-cohort-enabled': 'user_nextauth_id',
    'asi-improve-skill-enabled': 'user_nextauth_id',
    'asi-knowledge-read-config': 'user_nextauth_id',
    'asi-local-subagent-enabled': 'user_nextauth_id',
    'assistant-meeting-bot': 'visitor_id',
    artifact_multiplayer_comments: 'user_nextauth_id',
    'thread-graphql': 'user_nextauth_id',
    'auto-open-artifacts': 'user_nextauth_id',
    'automations-v2': 'user_nextauth_id',
    'brain-galaxy-ui': 'user_nextauth_id',
    'braintree-discount-id': 'user_nextauth_id',
    'check-sources': 'visitor_id',
    'checkout-business-checkbox-to-enterprise-upsell': 'user_nextauth_id',
    'comet-control-browser-skill-enabled': 'comet_device_id',
    'comet-global-tabs-attachments-enabled': 'comet_device_id',
    'comet-mcp-enabled': 'visitor_id',
    'comet-web-onboarding-paywall': 'user_nextauth_id',
    'composer-sdk-migration-home': 'user_nextauth_id',
    'composer-sdk-migration-sidecar': 'user_nextauth_id',
    'composer-sdk-migration-verticals': 'user_nextauth_id',
    'composer-sdk-migration-automations': 'user_nextauth_id',
    'composer-sdk-migration-thread': 'user_nextauth_id',
    'computer-7-day-trial': 'user_nextauth_id',
    'computer-effort-rbac-enabled': 'user_nextauth_id',
    'computer-crowdstrike-admin-ui-enabled': 'user_nextauth_id',
    'computer-email-reply-all-enabled': 'user_nextauth_id',
    'teammate-access-controls-enabled': 'user_nextauth_id',
    'teammate-connections': 'user_nextauth_id',
    'unified-ui-sidebar': 'visitor_id',
    'computer-neo-onboarding-primer-card': 'user_nextauth_id',
    'computer-primers-v2': 'visitor_id',
    'computer-pro-credit-presets': 'user_nextauth_id',
    'computer-remotebox-picker': 'user_nextauth_id',
    'xplat-computer-remotebox-picker': 'user_nextauth_id',
    'computer-setup-checklist-connect-apps-modal': 'user_nextauth_id',
    'computer-thread-terminal': 'user_nextauth_id',
    'computer-upsell-preserve-homepage-mode': 'user_nextauth_id',
    'computer-web-extension-transport': 'user_nextauth_id',
    'computer-usage-analytics': 'user_nextauth_id',
    'computer-website-access-permissioning': 'user_nextauth_id',
    'computer-workflow-trigger-events': 'user_nextauth_id',
    'consumer-upgrade-welcome': 'user_nextauth_id',
    'conversational-onboarding-paid-enabled': 'user_nextauth_id',
    'connector-card-direct-install': 'user_nextauth_id',
    'connector-service-go-proxy-browser': 'user_nextauth_id',
    'connector-skills': 'user_nextauth_id',
    'connector-migration-backend-state-banner': 'user_nextauth_id',
    'in-thread-connector-migration-reconnect-card': 'user_nextauth_id',
    'custom-remote-mcps': 'user_nextauth_id',
    'data-map-skill-suggestion': 'user_nextauth_id',
    'desktop-app-composer-promo': 'user_nextauth_id',
    'devices-settings-enabled': 'user_nextauth_id',
    'document-review': 'visitor_id',
    'dr-computer-config': 'user_nextauth_id',
    'enable-connector-product-slices': 'user_nextauth_id',
    'enable-memory-in-context-panel': 'visitor_id',
    'enable-multi-connection-display': 'user_nextauth_id',
    'enable-project-quickstarts': 'visitor_id',
    'enterprise-admin-api-ui': 'user_nextauth_id',
    'enterprise-conversational-onboarding-enabled': 'user_nextauth_id',
    'enterprise-admin-recommended-connectors': 'user_nextauth_id',
    'enterprise-cancellation-flow': 'user_nextauth_id',
    'enterprise-connector-rbac-enabled': 'user_nextauth_id',
    'enterprise-deferred-scim-provisioning': 'user_nextauth_id',
    'enterprise-scim-welcome-email': 'user_nextauth_id',
    'enterprise-insights-special-access': 'user_nextauth_id',
    'enterprise-org-credential-vault-enabled': 'user_nextauth_id',
    'enterprise-seat-capacity-rollout-stage': 'user_nextauth_id',
    'example-skills-v2': 'user_nextauth_id',
    'expand-cursor': 'user_nextauth_id',
    'explicit-free-turn-branding': 'user_nextauth_id',
    'fable-model-toggle-for-admin': 'user_nextauth_id',
    'file-upload-computer-tooltip': 'user_nextauth_id',
    'finance-connect-account-modal-v2': 'visitor_id',
    'finance-native-file-viewer': 'visitor_id',
    'finance-personal-holdings': 'visitor_id',
    'finance-polymarket-trending-search': 'visitor_id',
    'finance-related-queries': 'visitor_id',
    'finance-screener-computer': 'visitor_id',
    'finance-singular-ads-login-gate': 'visitor_id',
    'finance-timeline-ui-enabled': 'user_nextauth_id',
    'finance-workflows-catalog-config': 'visitor_id',
    'finance-workflows-config': 'user_nextauth_id',
    'full-screen-comet-upsell': 'user_nextauth_id',
    'function-health-connector': 'visitor_id',
    'health-gallery-tab': 'visitor_id',
    'is-health-assistant-enabled': 'visitor_id',
    'is-health-lab-upload-enabled': 'user_nextauth_id',
    'is-medical-records-enabled': 'visitor_id',
    'knowledge-diff-viewer-enabled': 'visitor_id',
    'limited-free-tier-experience': 'user_nextauth_id',
    'login-design': 'visitor_id',
    'marketing-gen-computer-fastanim': 'visitor_id',
    'marketing-gen-computer-prereport': 'visitor_id',
    'max-upsell': 'visitor_id',
    'maybe-student-domains-regex': 'visitor_id',
    'memory-search-history': 'user_nextauth_id',
    'microsoft-picker-shared-oauth-callback': 'user_nextauth_id',
    'mixed-interval-subscription': 'user_nextauth_id',
    'move-citations-to-paragraph-end': 'visitor_id',
    'mweb-followup-input': 'visitor_id',
    'news-tab': 'visitor_id',
    'org-minimax-toggle-enabled': 'user_nextauth_id',
    'org-overview-analytics-migration': 'user_nextauth_id',
    'org-seedance-toggle-enabled': 'user_nextauth_id',
    'patents-computer-relaunch': 'visitor_id',
    'permissions-platform-plugin-rbac-v0-enabled': 'user_nextauth_id',
    'perplexity-finance-uxr-prompt': 'user_nextauth_id',
    'personal-computer-local-inference-kill-switch': 'user_nextauth_id',
    'personal-cfo-rename-and-hide': 'user_nextauth_id',
    'personal-finance-canopy': 'visitor_id',
    'personal-finance-claim-masking-enabled': 'user_nextauth_id',
    'personal-finance-crypto': 'visitor_id',
    'personal-finance-related-queries': 'user_nextauth_id',
    'plaid-new-welcome-flow': 'visitor_id',
    'plugin-entities-enabled': 'user_nextauth_id',
    'plugins-skill-admin-settings': 'user_nextauth_id',
    'pro-checkout-last-mile-upsell': 'user_nextauth_id',
    'pro-perks-settings-flag': 'user_nextauth_id',
    'projects-sidebar-creation': 'user_nextauth_id',
    'projects-ui-simplification': 'user_nextauth_id',
    'pronunciation-annotations': 'visitor_id',
    'early-access-plugins-org-enrolled': 'user_nextauth_id',
    'realtime-computer-session-enabled': 'visitor_id',
    'sandbox-files-panel': 'visitor_id',
    'self-serve-org-delete': 'user_nextauth_id',
    'sharing-permissions-ui': 'user_nextauth_id',
    'show-brain-toggle-on-org-account-page': 'visitor_id',
    'sidecar-back-to-thread-button': 'visitor_id',
    'site-specific-prompt-teachers': 'visitor_id',
    'skill-upload-duplicate-detection-ui': 'user_nextauth_id',
    'smb-onboarding-connector-select-then-connect': 'user_nextauth_id',
    'source-rating-form': 'visitor_id',
    'show-sapi-hit-snippet': 'visitor_id',
    'source-suggestion-keywords': 'visitor_id',
    'swap-checkout-screen-order': 'user_nextauth_id',
    'talk-to-sales-upsells': 'user_nextauth_id',
    'tasks-free-user-access-enabled': 'user_nextauth_id',
    'thread-open-at-latest-query': 'user_nextauth_id',
    'thread-user-mentions': 'user_nextauth_id',
    'todo-widget': 'comet_device_id',
    'totp-2fa-enabled': 'user_nextauth_id',
    'viewer-analytics-recent-viewers-ui': 'user_nextauth_id',
    'web-frontend-overlay-stacking': 'user_nextauth_id',
    'web-hard-login-gate': 'visitor_id',
    'web-pptx-viewer': 'visitor_id',
    'web-project-artifacts-tab': 'user_nextauth_id',
    'web-sidebar-grouped-history': 'user_nextauth_id',
    'web-teammates-ui': 'user_nextauth_id',
    'teammate-project-environment-credentials-enabled': 'user_nextauth_id',
    'teammate-environment-snapshot': 'user_nextauth_id',
    'teammate-pull-request-local-comments': 'user_nextauth_id',
    'teammate-pull-request-review-actions': 'user_nextauth_id',
    'teammate-shared-agents': 'user_nextauth_id',
    'teammate-tweaks': 'user_nextauth_id',
    'website-publishing-enabled': 'user_nextauth_id',
    'windows-external-browser-extension': 'visitor_id',
    'windows-legacy-app-signed-in-handoff': 'user_nextauth_id',
    'workflow-carousel': 'visitor_id',
    'xplat-experimental': 'visitor_id',
    'xplat-auto-feedback': 'user_nextauth_id',
    'xplat-input': 'user_nextauth_id',
    'xplat-computer-effort-ui': 'visitor_id',
    'xplat-composer-native-dictation': 'user_nextauth_id',
    'xplat-advisor-agent-proxy': 'visitor_id',
    'xplat-voice-session-config': 'user_nextauth_id',
    'xplat-windows-portable-computer': 'visitor_id',
};
const EPPO_FRONTEND_FLAG_ALIASES = {};
function getEppoFrontendFlagAliasMetadata(flagKey) {
    return EPPO_FRONTEND_FLAG_ALIASES[flagKey];
}
export function getEppoFlagSubjectType(flagKey) {
    return (getEppoFrontendFlagAliasMetadata(flagKey)?.subjectType ??
        EPPO_FLAG_SUBJECT_TYPES[flagKey]);
}
export function getEppoAssignmentFlagKey(flagKey) {
    return getEppoFrontendFlagAliasMetadata(flagKey)?.eppoFlagKey ?? flagKey;
}
//# sourceMappingURL=eppoSubjectTypes.js.map